import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../NavigationContainer.vue";
import Loading from "@/components/home/Loading.vue";
import SideMenu from "@/components/scan/parts/SideMenu.vue";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import UserInfoDataService from "@/services/UserInfoDataService";
import { reactive, ref, onMounted, watch } from "vue";
import { useI18n } from "vue3-i18n";
import { useRouter } from "vue-router";
import Alert from "@/components/scan/parts/Alert.vue";
import NewsAndFAQ from "@/components/scan/newsinfo/newsAndFAQ.vue";
import CategoryEdit from "@/components/scan/admin/CategoryEdit.vue";
import ManualEdit from "@/components/scan/admin/ManualEdit.vue";
import FAQEdit from "@/components/scan/admin/FAQEdit.vue";
import StationCodeForSystemList from "@/components/scan/admin/StationCodeForSystemList.vue";
import StationCodeList from "@/components/scan/admin/StationCodeList.vue";
import StationCodeForSystemRegistration from "@/components/scan/admin/StationCodeForSystemRegistration.vue";
import StationCodeRegistration from "@/components/scan/admin/StationCodeRegistration.vue";
import UserApproval from "@/components/scan/admin/UserApproval.vue";
import PermissionsApproval from "@/components/scan/admin/PermissionsApproval.vue";
import UserInquiryByDestination from "@/components/scan/userlist/UserInquiryByDestination.vue";
import UserInquiryByUserID from "@/components/scan/userlist/UserInquiryByUserID.vue";
import NewsEdit from "@/components/scan/admin/NewsEdit.vue";
import NewsAdminEdit from "@/components/scan/admin/NewsAdminEdit.vue";
import UserInformation from "@/components/scan/userlist/UserInformation.vue";
import UserMaintenance from "@/components/scan/userlist/UserMaintenance.vue";
import SubMenuList from "@/components/scan/parts/SubMenu.vue";
import DistAdminList from "@/components/scan/admin/DistAdminList.vue";
import DistAdminRegisteration from "@/components/scan/admin/DistAdminRegisteration.vue";
import GroupAdminList from "@/components/scan/admin/GroupAdminMaintenance.vue";
import GroupAdminRegisteration from "@/components/scan/admin/GroupAdminRegisteration.vue";
import PwdResetRequest from "@/components/scan/admin/PwdResetRequest.vue";
import MenuPermissionInquiry from "@/components/scan/admin/MenuPermissionInquiry.vue";
import MenuApprovalHistory from "@/components/scan/admin/MenuApprovalHistory.vue";
import NewsMailMaintenance from "@/components/scan/admin/NewsMailMaintenace.vue"
import UserListDataService from "@/services/UserListDataService";
import LoginAdminMaintenance from "@/components/scan/admin/LoginAdminMaintenance.vue";
import TechnicalDocument from "@/components/scan/regulations/TechnicalDocumentationCategory.vue";
import CategoryDocumentMaintenance from "@/components/scan/regulations/CategoryAndDocumentMaintenance.vue";
import RetailDataMaintenance from "@/components/scan/connectedretail/RetailDataMaintenance.vue";
import MenuStationMappingMaintenance from "@/components/scan/admin/MenuStationMappingMaintenance.vue";
import WarrantyClaim from "@/components/scan/aftersale/WarrantyClaim.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const items = reactive([]);
const isOpen = reactive([]);
const isSubMenuOpen = reactive([]);
const tmpCodeWithSubMenu =  reactive([]);
const destinationList = reactive([]);
// creates a reference to Vue router
const router = useRouter();

onMounted(async () => {
  if (store.state.items.length === 0) {
    isLoading.value = true;
    await Promise.all([
      getSideMenuList(),
      checkApprovalRequest(),
      getDestinaionList()
    ]);
  }
});

const getSideMenuList = () => {
  UserInfoDataService.getSideMenuList({
    data: store.getters.cognitoUserName,
  })
    .then((response: ResponseData) => {
      items.splice(0);
      tmpCodeWithSubMenu.splice(0);
      isOpen.splice(0);

      items.push(response.data);
      const tmp = new Array(items[0].length);
      for (let i = 0; i < items[0].length; i++) {
        isOpen.push(true);
        if ("data" in items[0][i]) {
          tmp[i] = [];
          for (let j = 0; j < items[0][i]["data"].length; j++) {
            tmp[i].push(false);
            if(items[0][i]["data"][j] == null || items[0][i]["data"][j].url == "" || items[0][i]["data"][j].url == "None"){
              tmpCodeWithSubMenu.push(items[0][i]["data"][j])
            }
          }
        }
      }
      store.dispatch("setSubExistMenu", tmpCodeWithSubMenu);
      store.dispatch("setItems", response.data);
      store.dispatch("setIsOpen", isOpen);
      store.dispatch("setIsSubMenuOpen", tmp);
      isSubMenuOpen.push(tmp);
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
    });
}
store.dispatch("setShowPage", "/");

/** Destinationコンボボックスデータ取得 */
const getDestinaionList = () => {
  UserListDataService.getDestinationList()
    .then((response: ResponseData) => {
      if (response.data.length > 0) {
        destinationList.splice(0);
        destinationList.push(response.data);
        store.dispatch("setStationListData", destinationList[0]);
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err022");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** 承認依頼があるかチェック */
const checkApprovalRequest = () => {
  const data = {'userId': store.getters.cognitoUserName};
  UserInfoDataService.checkApprovalRequest(data)
  .then((response: ResponseData) => {
    var data = response.data;
    var msgVal = "You have received a request to confirm User Approval or/and Menu Approval. Please go to the page from Admin menu.";
    if(data.isNodeAdminNotice || data.isSmcAdminNotice){
      store.dispatch("setApprovalNotice", msgVal);
    }else{
      store.dispatch("setApprovalNotice", "");
    }
  })
};

watch(() => [store.getters.cognitoUserName], async function () {
    isLoading.value = true;
    if(store.state.isAltLogin == true){
      // 成り代わりログインの場合、ユーザー情報を再取得する
      await Promise.all([
        getSideMenuList(),
        checkApprovalRequest(),
        setUserInfo(store.getters.cognitoUserName)
      ]);
    }else{
      // 本人の場合、AuthenticateFormにユーザー情報取得済み或は成り代わりログイン前の保管情報があるため、再取得しない
      await Promise.all([
        getSideMenuList(),
        checkApprovalRequest()
      ]);
    }
    if(store.state.isAltLogout == true){
      console.log("relogout");
      store.dispatch("setIsAltLogout", false);
    }else{
      console.log("relogin");
    }
  }
);

/** ユーザー情報を取得してstoreに格納 */
const setUserInfo = (userId: any) => {
  UserInfoDataService.getUserInfo(userId)
    .then((response: ResponseData) => {
      const userInfo = response.data;
      store.dispatch("setEmail", userInfo.email);
      store.dispatch("setGivenName", userInfo.givenName);
      store.dispatch("setFamilyName", userInfo.familyName);
      store.dispatch("setStationCode", userInfo.stationCode);
      store.dispatch("setLoginNumber", userInfo.loginNumber);
      store.dispatch("setCompanyName", userInfo.companyName);
      store.dispatch("setTitle", userInfo.title);
      store.dispatch("setDepartment", userInfo.department);
      store.dispatch("setIsAltLoginAdmin", userInfo.altLoginAdmin > 0? true: false);
    })
    .catch((e: Error) => {
      console.log(e.message);
      router.push("/ErrorPage");
    });
};

const __returned__ = { isLoading, alertMessage, alertState, i18n, items, isOpen, isSubMenuOpen, tmpCodeWithSubMenu, destinationList, router, getSideMenuList, getDestinaionList, checkApprovalRequest, setUserInfo, Navigation, Loading, SideMenu, store, Alert, NewsAndFAQ, CategoryEdit, ManualEdit, FAQEdit, StationCodeForSystemList, StationCodeList, StationCodeForSystemRegistration, StationCodeRegistration, UserApproval, PermissionsApproval, UserInquiryByDestination, UserInquiryByUserID, NewsEdit, NewsAdminEdit, UserInformation, UserMaintenance, SubMenuList, DistAdminList, DistAdminRegisteration, GroupAdminList, GroupAdminRegisteration, PwdResetRequest, MenuPermissionInquiry, MenuApprovalHistory, NewsMailMaintenance, LoginAdminMaintenance, TechnicalDocument, CategoryDocumentMaintenance, RetailDataMaintenance, MenuStationMappingMaintenance, WarrantyClaim }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})